import { render, staticRenderFns } from "./medal.vue?vue&type=template&id=03bce479&"
import script from "./medal.vue?vue&type=script&lang=js&"
export * from "./medal.vue?vue&type=script&lang=js&"
import style0 from "./medal.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports